<script setup>
import { getI18n } from '@/plugins/i18n'

import { useWebSiteStore } from '@/stores/web-site.store'
import { useNotify } from '@/composables/notify'
import { usePolling } from '@/composables/polling'

import { storeToRefs } from 'pinia'

const i18n = getI18n()
const webSiteStore = useWebSiteStore()
const { notifyInfo } = useNotify()
const { notificationsCount } = storeToRefs(webSiteStore)

const openNotifications = () => { webSiteStore.showNotifications = true }

const pollUnreadCountAsync = async() => {
  if (!await webSiteStore.pollNotificationsUnreadCountAsync()) return
  notifyInfo(i18n.t('common.newNotification', notificationsCount.value), {
    timeout: 1000,
    actions: [{ icon: 'mdi-magnify', color: 'white', handler: openNotifications }]
  })
}

usePolling(pollUnreadCountAsync)

</script>

<template>
  <q-btn
    flat
    round
    dense
    icon="mdi-bell"
    class="q-mr-sm q-ml-sm"
    :aria-label="i18n.t('menu.notifications')"
    @click="webSiteStore.showNotifications = !webSiteStore.showNotifications"
  >
    <q-badge
      v-if="notificationsCount > 0"
      color="red"
      :label="notificationsCount"
      floating
      rounded
    />
    <q-tooltip>{{ i18n.t('menu.notifications') }}</q-tooltip>
  </q-btn>
</template>
